export function resolveAvatarSrc(url: string | null | undefined): string | undefined {
  if (!url) return undefined
  if (url.startsWith('/')) return `${process.env.VUE_APP_API_URL}${url}`
  return url
}
